import { CommentConfig } from "component/comment";
import { Feature } from "util/stdtypes";
import type { Comment } from "component/comment";
import { Datastore } from "util/datastore";
import { reactionTable, upvoteTable } from "util/stdconfig";

export const MostRecentFeature : Feature<CommentConfig, {}> = {
    name: 'Newest',
    key: 'most-recent',
    dev: true,
    config: {
        commentRankers: [{label: 'Newest', ranker: mostRecentRanker}]
    }
}

export function mostRecentRanker(datastore : Datastore, comments : Comment[]) {
    return comments.sort((a, b) => b.time - a.time);
}


export const OldestFeature : Feature<CommentConfig, {}> = {
    name: 'Oldest',
    key: 'oldest',
    dev: true,
    config: {
        commentRankers: [{label: 'Oldest', ranker: oldestRanker}]
    }
}

function oldestRanker(datastore : Datastore, comments : Comment[]) {
    return comments.sort((a, b) => a.time - b.time);
}


export const MostUpvotedFeature : Feature<CommentConfig, {}> = {
    name: 'Most Upvoted',
    key: 'most-upvoted',
    dev: true,
    config: {
        commentRankers: [{label: 'Most Upvoted', ranker: mostUpvotedRanker}]
    }
}   

function mapByKey(collection, func) {
    const map = {};
    collection.forEach(item => {
        map[item.key] = func(item);
    });
    return map;
}

function mostUpvotedRanker(datastore : Datastore, comments : Comment[]) {
    const upvotes = datastore.getCollection(upvoteTable);
    const upvoteCounts = mapByKey(comments, comment => upvotes.filter(upvote => upvote.comment === comment.key).length);
    return comments.sort((a, b) => upvoteCounts[b.key] - upvoteCounts[a.key]);
}

export const MostReactedFeature : Feature<CommentConfig, {}> = {
    name: 'Most Reactions',
    key: 'most-reactions',
    dev: true,
    config: {
        commentRankers: [{label: 'Most Reactions', ranker: mostReactionsRanker}]
    }
}   

function mostReactionsRanker(datastore : Datastore, comments : Comment[]) {
    const reactions = datastore.getCollection(reactionTable);
    const reactionCounts = mapByKey(comments, comment => reactions.filter(reaction => reaction.reactTo === comment.key).length);
    return comments.sort((a, b) => reactionCounts[b.key] - reactionCounts[a.key]);
}

